// extracted by mini-css-extract-plugin
module.exports = {"box_item":"styles_box_item__WCVyz","heading":"styles_heading__Nk2Z3"};